import { useNavigate } from "react-router-dom";
import {
    Mail,
    Phone,
    MapPin,
    Eye,
} from "lucide-react";

import "./CustomerTable.css";

function CustomerTable({
    customers,
    loading,
}) {

    const navigate = useNavigate();

    if (loading) {

        return (
            <div className="table-loading">
                Loading Customers...
            </div>
        );

    }

    if (!customers.length) {

        return (
            <div className="table-empty">
                <h2>No Customers Found</h2>
            </div>
        );

    }

  return (

    <div className="customer-table-card">

        <div className="customer-table-header">

            <h2>Customers</h2>

            <span>

                Total Customers : {customers.length}

            </span>

        </div>

        <div className="customer-table-container">

            <table className="customer-table">

                <thead>

                    <tr>

                        <th>Customer</th>
                        <th>Contact</th>
                        <th>Location</th>
                        <th>Status</th>
                        <th>Joined</th>
                        <th>Action</th>

                    </tr>

                </thead>

                <tbody>

                    {customers.map((customer) => (

                        <tr key={customer._id}>

                            <td>

                                <div className="customer-info">

                                    <div className="customer-avatar">

                                        {customer.name
                                            ?.charAt(0)
                                            .toUpperCase()}

                                    </div>

                                    <div>

                                        <h4>{customer.name}</h4>

                                        <span>{customer.email}</span>

                                    </div>

                                </div>

                            </td>

                            <td>

                                <div className="contact-info">

                                    <div>

                                        <Phone size={14} />

                                        {customer.phone}

                                    </div>

                                    <div>

                                        <Mail size={14} />

                                        {customer.email}

                                    </div>

                                </div>

                            </td>

                            <td>

                                <div className="location-info">

                                    <MapPin size={14} />

                                    {customer.city || "Not Available"}

                                </div>

                            </td>

                            <td>

                                <span
                                    className={
                                        customer.isActive
                                            ? "customer-status active"
                                            : "customer-status blocked"
                                    }
                                >

                                    {customer.isActive
                                        ? "Active"
                                        : "Blocked"}

                                </span>

                            </td>

                            <td>

                                {new Date(
                                    customer.createdAt
                                ).toLocaleDateString("en-IN")}

                            </td>

                            <td>

                               <button
    className="view-details-btn"
    onClick={() =>
        navigate(`/admin/customers/${customer._id}`)
    }
>

    <Eye size={18} />

    View

</button>

                            </td>

                        </tr>

                    ))}

                </tbody>

            </table>

        </div>

    </div>

);

}

export default CustomerTable;